
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Button,
    FormControl,
    Input,
    FormLabel,
    useToast,
    FormHelperText,
    Select as ChakraSelect,
  } from "@chakra-ui/react";
  import Select from 'react-select';
  import BookingDataService from "../../services/Booking";
  import React, { useEffect, useState } from "react";
  import { Spinner } from "@chakra-ui/react";
  import ExpertDataService from "../../services/Expert";
import { DateTime } from "luxon";
  export default function DownloadExpertBilingModal({ isOpen, onClose }: any) {
    const toast = useToast();
    const token = localStorage.getItem("logged_in_user_token");
    const [expertList, setExpertList] = useState<any>([]);
    const [downloadLoader, setdownloadLoader] = useState<any>(false);
    const [fromDate, setFromDate] = useState("");
    const [expert, setExpert] = useState("");
    const [toDate, setToDate] = useState("");
    const [selectedValue, setSelectedValue] = useState("");
    const initialRef = React.useRef(null);
    const options = expertList.map((el:any) => ({
      value: el._id,
      label: el.data.full_name,
    }));

function formatDate(date:any) {
  return DateTime.fromISO(date).toFormat('dd LLL yyyy');
}

    const getFileName =(fromDate:string, toDate:string, expertName:string) => {
      let fileName = "data";
      
      if (fromDate && toDate) {
          fileName += `_from_${formatDate(fromDate)}_to_${formatDate(toDate)}`;
      } else if (fromDate) {
          fileName += `_from_${formatDate(fromDate)}_to_now`;
      } else if (toDate) {
          fileName += `_to_${formatDate(toDate)}`;
      }
  
      if (expertName) {
          fileName += `_expert_${expertName}`;
      }
  
      if (!fromDate && !toDate && !expertName) {
          fileName += `_all_data`;
      }
      
      fileName += ".xlsx";
      return fileName;
  }
    const handleSubmit = () => {
      setdownloadLoader(true);
      let downloadText = ""
      BookingDataService.downloadExpertBiling(fromDate, toDate,expert)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", getFileName(fromDate, toDate,expert));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          toast({
            position: "top",
            title: "Billing Sheet Downloaded Successfully",
            description: "The billing sheet has been downloaded successfully",
            status: "success",
            duration: 1500,
            isClosable: true,
          });
        })
        .catch((error) => {
          console.error("Error downloading payments:", error.message);
          toast({
            position: "top",
            title: "Billing Sheet Download Failed",
            description:
              "There was an error downloading the billing sheet. Please try again later.",
            status: "error",
            duration: 1500,
            isClosable: true,
          });
        })
        .finally(() => {
          setdownloadLoader(false);
          onClose();
        });

    };
    function getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    function getFirstDateOfCurrentMonth() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = "01";
      return `${year}-${month}-${day}`;
    }
    const handleSelecion = (value: any) => {
      if (value === "today") {
        setFromDate(getTodayDate);
        setToDate(getTodayDate);
      } else if (value === "month") {
        setFromDate(getFirstDateOfCurrentMonth);
        setToDate(getTodayDate);
      } else {
        setFromDate("");
        setToDate("");
      }
      setSelectedValue(value);
    };
    const fetchExperts = () => {
        ExpertDataService.getExperts(token)
        .then((res: any) => {
          setExpertList(res.data);
        })
        .catch((error: any) => {
          console.log(error);
        });
      }
      useEffect(()=>{
        fetchExperts();
      },[])
    return (
      <>
        <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Choose Date Range</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
            <FormControl>
          <FormLabel htmlFor="expert">Select Expert:</FormLabel>
          <Select
            id="expert"
            name="expert"
            options={options}
            placeholder="Choose Expert"
            isClearable
            value={options.find((option:any) => option.value === expert)}
            onChange={(option:any) => setExpert(option ? option.value : null)}
          />
          {/* <FormHelperText>Choose an expert from the list</FormHelperText> */}
        </FormControl>
              <FormControl mt={5}>
                <ChakraSelect
                  value={selectedValue}
                  onChange={(e) => handleSelecion(e.target.value)}
                >
                  <option value="">Choose Time</option>
                  <option value="today">Today</option>
                  <option value="month">Current Month</option>
                  <option value="all">All Payments</option>
                </ChakraSelect>
              </FormControl>
              <FormControl mt={4}>
                <FormLabel>From</FormLabel>
                <Input
                  value={fromDate}
                  type="date"
                  ref={initialRef}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </FormControl>
  
              <FormControl mt={2}>
                <FormLabel>To</FormLabel>
                <Input
                  value={toDate}
                  type="date"
                  ref={initialRef}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </FormControl>
            </ModalBody>
  
            <ModalFooter>
              <Button
                bgColor="#327171"
                color={"white"}
                mr={3}
                onClick={handleSubmit}
              >
                {downloadLoader ? <Spinner size="sm" /> : "Download"}
              </Button>
              <Button bgColor="red" color={"white"} onClick={onClose}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  }
  